import React, { Component } from "react";
import {
  Form,
  FormField,
  TextBox,
  NumberBox,
  Panel,
  LinkButton,
  Messager,
  ComboBox,
} from "rc-easyui";

import { isEmpty, generateErrorString } from "../../../helpers";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { API_URL } from "../../../constants";
import { Button } from "reactstrap";
import PropTypes from "prop-types";

const axios = require("axios");

class CreateMarketingAgent extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false, isPersonel: false };
    this.handleSave = this.handleSave.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  handleChange(name, value) {
    // console.log(name, value)
    if (name === 'agentType' && value === 'individual') {
      this.setState({isPersonel: true})
     
    
    } else if (name === 'agentType' && value === 'organization') {
      this.setState({isPersonel: false})
    }
    
      
      this.props.handleChange(name, value);
    
  }
 

  handleUpdate() {
    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");
    var { form } = this.props;
    if(form['agentType'] === 'organization') {
      if(form['officeContact'] === null || form['contactPersonName'] === null) {
        this.messager.alert({
          title: 'Error',
          icon: 'error',
          msg: 'Contact person Name and office contact is required when agentType is organization.',
        })
        return
      }
    }
    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };

    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (access_token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          //console.log(form);
          axios
            .put(API_URL + "api/savemarketingagent/", form, axiosConfig)
            .then((response) => {
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    reload: true,
                  }); // Price Plan Updated Successfully ie. 200
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: `${response.data.object} and office contact is required when agentType is organization.`,
                  });
                  // this.setState({
                  //   isLoading: false,
                  // });
    
                  // var message = "";
                  // if (response.data.object) {
                  //   response.data.object.forEach((row, i) => {
                  //     message += row;
                  //   });
                  // } else {
                  //   message = response.data.object;
                  // }
                  // this.messager.alert({
                  //   title: "Error",
                  //   icon: "error",
                  //   type: "alert",
                  //   msg: `${message} and office contact is required when agentType is organization.`,
                  // });
                
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.field.toUpperCase() +
                      " " +
                      row.defaultMessage +
                      "</p>";
                  });
                  //console.log(message);
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleUpdate();
          }
        }
      } else {
        generateErrorString(errors);
        console.log(errors)
      }
    });
  }

  async handleSave() {
    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");
    var { form } = this.props;
    form["createdBy"] = getCookie("username");
    if(form['agentType'] === 'organization') {
      if(form['officeContact'] === "" || form['contactPersonName'] === "") {
        this.messager.alert({
          title: 'Error',
          icon: 'error',
          msg: 'Contact person Name and office contact is required when agentType is organization.',
        })
        return
      }
    }
    
    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };


    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (access_token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });

          var response = await axios.post(
            API_URL + "api/savemarketingagent",
            form,
            axiosConfig
          );
          if (response.status === 200) {
            this.setState({
              isLoading: false,
            });
            if (response.data.status) {
              this.messager.alert({
                title: "Success",
                msg: response.data.message,
                reload: true,
              }); // Marketing Agent Saved Successfully ie. 200
            } else {
              this.messager.alert({
                title: "Error",
                msg: `${response.data.object} and office contact is required when agentType is organization.`,
              });
            }
          } else {
            this.messager.alert({
              title: "Error",
              msg: "Uncaught Error",
              reload: false,
            });
          }
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleSave();
          }
        }
      } else {
        generateErrorString(errors);
      }
    });
  }

  render() {
    const { form, isPersonel } = this.props;
    const rules = this.props.validationRules;
    const status = this.props.enabled;
    const loading = this.state.isLoading;
    const operation = this.props.operation;
    
    return (
      <div>
        <div
          className="loadingmodel"
          style={{ display: loading ? "block" : "none" }}
        ></div>
        <Panel title="Create Marketing Agent" bodyStyle={{ padding: 20 }}>
          <Messager
            ref={(ref) => (this.messager = ref)}
            showHeader={false}
            borderType="none"
            content={({ title, msg, buttons, reload }) => (
              <div className="alert-content">
                <h3>{title}</h3>
                <div
                  style={{ marginBottom: 5 }}
                  dangerouslySetInnerHTML={{ __html: msg }}
                ></div>
                <div className="m-buttons">
                  {buttons.map((button, index) => (
                    <LinkButton
                      key={index}
                      text={button.text}
                      onClick={() => {
                        this.messager.close(button);
                        if (reload) {
                          window.location.reload();
                        }
                      }}
                    />
                  ))}
                </div>
              </div>
            )}
          />
          <Form
            ref={this.props.innerRef}
            model={form}
            labelWidth={400}
            labelAlign="left"
            rules={rules}
            labelPosition="top"
            onChange={this.handleChange.bind(this)}
          >
            <FormField name="agentType" label="Agent Type:">
              <ComboBox
                data={[
                  { value: "organization", text: "Organization" },
                  { value: "individual", text: "Individual" },
                ]}
                value={form.agentType}
                style={{ width: "100%", height: 30 }}
                editable={false}
              ></ComboBox>
            </FormField>

            <FormField name="agentName" label="Agent Name:">
              <TextBox
                value={form.agentName}
                style={{ width: "100%" }}
              ></TextBox>
            </FormField>

            <FormField name="address" label="Address:">
              <TextBox
                value={form.address}
                style={{ width: "100%", height: 50 }}
                multiline
              ></TextBox>
            </FormField>

            <FormField name="panNo" label="Pan No:">
              <TextBox value={form.panNo} style={{ width: "100%" }}></TextBox>
            </FormField>

            <FormField name="marketingArea" label="Marketing Area:">
              <TextBox
                value={form.marketingArea}
                style={{ width: "100%" }}
              ></TextBox>
            </FormField>

            <FormField name="profitSharingTerms" label="Profit Sharing Terms:">
              <TextBox
                value={form.profitSharingTerms}
                style={{ width: "100%" }}
              ></TextBox>
            </FormField>

            <FormField
              name="rolesAndResponsibilites"
              label="Roles And Responsibilites:"
            >
              <TextBox
                value={form.rolesAndResponsibilites}
                style={{ width: "100%" }}
              ></TextBox>
            </FormField>

            <FormField name="contactNo" label="Contact No:">
              <TextBox
                value={form.contactNo}
                style={{ width: "100%" }}
              ></TextBox>
            </FormField>

            <FormField name="altContactNo" label="Alt Contact No:">
              <TextBox
                value={form.altContactNo}
                style={{ width: "100%" }}
              ></TextBox>
            </FormField>

           {!this.state.isPersonel ? 
             <FormField name="officeContact" label="Office Contact:">
             <TextBox
               value={form.officeContact}
               style={{ width: "100%" }}
             ></TextBox>
              
           </FormField>
          
           :
            ""
          }

            {!this.state.isPersonel ?
            <FormField name="contactPersonName" label="Contact Person Name:">
            <TextBox
              value={form.contactPersonName}
              style={{ width: "100%" }}
            ></TextBox>
            
          </FormField>
            :
            ""
           } 

            {/* <FormField name="enabled" label="Status:">
              <ComboBox
                data={status}
                valueField="value"
                textField="text"
                value={form.enabled}
                editable={false}
              ></ComboBox>
            </FormField> */}

            <hr />
            <div className="text-center">
              <Button
                color="primary"
                disabled={loading ? true : false}
                onClick={
                  operation === "Add" ? this.handleSave : this.handleUpdate
                }
                style={{ marginRight: 20 }}
              >
                {operation === "Add" ? "Save" : "Update"}
              </Button>
              <Button color="danger" onClick={this.props.formClear}>
                Cancel
              </Button>
            </div>
          </Form>
        </Panel>
      </div>
    );
  }
}

export default React.forwardRef((props, ref) => (
  <CreateMarketingAgent innerRef={ref} {...props} />
));
